import { useEffect, useState } from 'react';
import { getDownloadUrl } from '../../services/api/fileService';

export const useFileUrl = (fileId: string | null | undefined) => {
    const [url, setUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!fileId) {
            setUrl(null);
            return;
        }
        let cancelled = false;
        const load = async () => {
            try {
                const next = await getDownloadUrl(fileId);
                if (!cancelled) setUrl(next);
            } catch (error) {
                console.error('Failed to fetch file URL:', error);
            }
        };
        load();
        return () => {
            cancelled = true;
        };
    }, [fileId]);

    return url;
};
